import type * as React from "react";
import { useLingui } from "@lingui/react/macro";
import { Dropdown } from "./Dropdown";

/** 선택 가능한 언어 목록. 값은 @app/i18n 의 SUPPORTED_LOCALES 와 동기화.
    라벨은 각 언어의 고유 표기라 번역하지 않는다. */
export const LOCALE_OPTIONS: { value: string; label: string }[] = [
  { value: "ko", label: "한국어" },
  { value: "en", label: "English" },
];

export interface LocaleSelectProps {
  value: string;
  onChange?: (value: string) => void;
  className?: string;
  /** 주면 트리거가 라벨 대신 이 아이콘만 보이는 아이콘 버튼이 돼요(공개 링크 헤더용). */
  icon?: React.ReactNode;
}

/** UI 언어를 고르는 드롭다운 (설정 페이지용). */
function LocaleSelect({ value, onChange, className, icon }: LocaleSelectProps) {
  const { t } = useLingui();
  return (
    <Dropdown
      title={t`언어`}
      options={LOCALE_OPTIONS}
      value={value}
      onChange={onChange}
      className={className}
      icon={icon}
    />
  );
}
LocaleSelect.displayName = "LocaleSelect";

export { LocaleSelect };
